import store from '../store/index'
import axios from './axios_iface'
import md5 from 'md5'

import moment from 'moment-timezone'

export function determineIncludedStores(availablity_record, stores_data) {
  var final_stores = {}
  for (var store of stores_data) {
    var exists = false
    if (availablity_record.excl.stores.includes(store._id)) {
      continue
    }
    if (availablity_record.incl.stores.includes(store._id)) {
      exists = true
    }
    if (availablity_record.excl.cities.includes(store.city)) {
      continue
    }
    if (availablity_record.incl.cities.includes(store.city)) {
      exists = true
    }
    if (availablity_record.excl.countries.includes(store.country)) {
      continue
    }
    if (availablity_record.incl.countries.includes(store.country)) {
      exists = true
    }
    if (availablity_record.incl.all) {
      exists = true
    }
    if (exists) {
      final_stores[store._id] = store
    }
  }
  return final_stores
}

export function log_data(data) {
  console.log(data)
  var xhr = new XMLHttpRequest()
  let protocol = process.env.NODE_ENV === 'production' ? 'https' : 'http'
  let port = process.env.NODE_ENV === 'production' ? '8071' : '8070'
  var url =
    protocol +
    '://listener.logz.io:' +
    port +
    '/?token=MwjAGKwiQJMBfsMZFMVWwYgLNRMTdqYS&type=MY-TYPE'
  xhr.open('POST', url, true)
  xhr.setRequestHeader('content-type', 'application/json')
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      console.log('logsent')
    }
  }
  var data = JSON.stringify(data)
  xhr.send(data)
}

export function raw_request(url, method, reqdata, headers = {}) {
  return new Promise((resolve, reject) => {
    function updateProgress(oEvent) {
      if (oEvent.lengthComputable) {
        var percentComplete = (oEvent.loaded / oEvent.total) * 100
        log_data({
          sent: percentComplete,
        })
        // ...
      } else {
        // Unable to compute progress information since the total size is unknown
        log_data({
          sent: 'unable to complete info',
        })
      }
    }

    function transferComplete(evt) {
      log_data({
        sent: 'complete transfer',
        event: evt,
      })
    }

    function transferFailed(evt) {
      log_data({
        sent: 'transfer failed',
        event: evt,
      })
    }

    function transferCanceled(evt) {
      log_data({
        sent: 'transfer cancelled by user',
        event: evt,
      })
    }

    var xhr = new XMLHttpRequest()
    xhr.addEventListener('progress', updateProgress)
    xhr.addEventListener('load', transferComplete)
    xhr.addEventListener('error', transferFailed)
    xhr.addEventListener('abort', transferCanceled)

    xhr.addEventListener('timeout', () => {
      reject('Request Timeout!!')
    })

    xhr.open('POST', url, true)

    for (var i in headers) {
      xhr.setRequestHeader(i, headers[i])
    }

    xhr.onreadystatechange = function() {
      // In local files, status is 0 upon success in Mozilla Firefox
      if (xhr.readyState === XMLHttpRequest.DONE) {
        console.log({
          status: xhr.status,
          response: xhr.response,
          responseText: xhr.responseText,
        })
        log_data({
          status: xhr.status,
          response: xhr.response,
          responseText: xhr.responseText,
        })
        var status = xhr.status
        if (status === 0 || (status >= 200 && status < 400)) {
          // The request has been completed successfully
          resolve({ data: JSON.parse(xhr.responseText) })
        } else {
          // Oh no! There has been an error with the request!
          reject(xhr.responseText)
        }
      }
    }
    var data = JSON.stringify(reqdata)
    xhr.send(data)
  })
}

export function process_warning(error, post_to_backend = true) {
  if (process.env.NODE_ENV === 'production' && post_to_backend) {
    axios.post(store.getters.logging_url, { warning: error })
  } else {
    // console.log(error)
  }
}

export function process_error(error, showNotification = true) {
  let error_message =
    'Error reported: ' + error + ', url: ' + document.location.href
  if (process.env.NODE_ENV === 'production') {
    axios.post(store.getters.logging_url, { error: error_message })
  }
  if (showNotification)
    store.dispatch('showNotification', { text: error, status: 'error' })
}

export function process_success(message, showNotification = true) {
  if (showNotification)
    store.dispatch('showNotification', { text: message, status: 'success' })
}

export function generate_error(message) {
  var exception = Error(message)
  process_error('Critical ' + exception, false)
}

export function hexToRgb(in_hex) {
  var hex = in_hex.replace('#', '')
  var arrBuff = new ArrayBuffer(4)
  var vw = new DataView(arrBuff)
  vw.setUint32(0, parseInt(hex, 16), false)
  var arrByte = new Uint8Array(arrBuff)
  return arrByte[1] + ',' + arrByte[2] + ',' + arrByte[3]
}

export function applyColoring() {
  var colors = store.getters.current_colors
  for (var item of Object.keys(colors)) {
    document.documentElement.style.setProperty(
      '--' + item,
      'rgb(' + hexToRgb(colors[item]) + ')'
    )
    document.documentElement.style.setProperty(
      '--' + item + '-source',
      hexToRgb(colors[item])
    )
  }
}

export function format_order_address(order) {
  var ar = []
  if (order.order_flat_number) ar.push(order.order_flat_number)
  if (order.order_building) ar.push(order.order_building)
  if (order.order_street) ar.push(order.order_street)
  if (order.order_city) ar.push(order.order_city)
  return ar.join(', ')
}

export function format_store_address(store) {
  var ar = []
  if (store.city) ar.push(store.city)
  if (store.address) ar.push(store.address)
  return ar.join(', ')
}

export function format_cust_address(address) {
  var ar = []
  if (address.flat_number) ar.push(address.flat_number)
  if (address.building) ar.push(address.building)
  if (address.street) ar.push(address.street)
  if (address.city) ar.push(address.city)
  return ar.join(', ')
}

export function debounce(func, wait, immediate) {
  let timeout
  return function(...args) {
    const context = this
    var later = function() {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}
export function date_time_utc(fmt_out = 'YYYY-MM-DD HH:mm:ss') {
  return moment.utc().format(fmt_out)
}
export function datetime_in_local_timezone(
  datetime,
  fmt_out = 'Do MMM YYYY,  hh:mm:ss A',
  offset = 0
) {
  if (typeof datetime === 'string') {
    return moment
      .utc(datetime)
      .local()
      .format(fmt_out)
  }
  var value = parseInt(datetime.$date.$numberLong)
  if (!moment.utc(value).isValid()) return ''
  if (offset) {
    return moment
      .utc(value)
      .add(offset, 'minutes')
      .local()
      .format(fmt_out)
  }
  return moment
    .utc(value)
    .local()
    .format(fmt_out)
}

export function datetime_in_store_timezone(
  datetime,
  timezone,
  fmt_out = 'Do MMM YYYY,  hh:mm:ss A'
) {
  /*if (store.all_stores_being_loaded || store.all_timezones_being_loaded) {
    var store = store.getters.find_brand_store_by_main_id(store_id)
    if (store) {
      var timezone = store.getters.find_timezone_by_main_id(store.timezone)*/
  if (timezone) {
    if (typeof datetime === 'string') {
      return moment
        .utc(datetime)
        .setTimezone(timezone)
        .format(fmt_out)
    }
    var value = parseInt(datetime.$date.$numberLong)
    if (!moment.utc(value).isValid()) return ''
    return moment
      .utc(value)
      .setTimezone(timezone)
      .format(fmt_out)
  }
  // }
  // }
  return store.getters.T('Loading...')
}

export function sort_field_by_attributes_function(attrib) {
  return function(f1, f2) {
    var result
    var a = f1[attrib]
    var b = f2[attrib]
    if (a === null) return 1
    if (b === null) return -1
    if (a === null && b === null) return 0

    result = a - b

    if (isNaN(result) && a) {
      return a ? a.toString().localeCompare(b) : null
    } else {
      return result
    }
  }
}

export function seo_name(name) {
  if (!name) return ''
  return name.toLowerCase().replace(/\s/g, '-')
}
export function resolve_seo_name(name) {
  return name.replace(/-/g, ' ').toLowerCase()
}

export function get_gravatar(email, size = 100) {
  return (
    'https://secure.gravatar.com/avatar/' +
    md5(email.toLowerCase().trim()) +
    '?s=' +
    size +
    '&d=identicon&r=PG'
  )
}

export function validateEmail(email) {
  var re = /\S+@\S+\.\S+/
  return re.test(String(email).toLowerCase())
}

export function validatePhoneNumber(phone_number) {
  var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im
  /* remove spaces and + */
  var n = String(phone_number)
    .replace(/\s+/g, '')
    .replace(/'+'/g, '')
  return re.test(String(n).toLowerCase())
}

export function getBaseUrl() {
  var docRoot = null
  try {
    var url = window.location.href.split('/')
    docRoot = `${url[0]}//${url[2]}/`
  } catch (e) {
    docRoot = store.getters.api_root_url
    // eslint-disable-next-line no-console
    console.warn(e)
  }
  return docRoot
}

export function generateRandomString() {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  )
}

export function handleApiErrors(errors) {
  let apiErrors = ''
  for (let i in errors) {
    if (typeof errors[i] === 'string') {
      apiErrors += ' ' + errors[i]
    } else {
      errors[i].forEach(err => (apiErrors += ' ' + err))
    }
  }
  return apiErrors
}
export function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object
}
export function objectToString(obj, glue = ' ') {
  let str = ''
  for (let key in obj) {
    str += obj[key] + glue
  }
  return str
}
export function isInViewport(element) {
  const rect = element.getBoundingClientRect()
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export function chunk(arr, len) {
  var chunks = [],
    i = 0,
    n = arr.length
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)))
  }
  return chunks
}

export function convert_datetime(
  datetime,
  fmt_out = 'Do MMM YYYY,  hh:mm:ss A',
  offset = 0,
  add_time = false
) {
  moment.locale(store['current_locale'])
  if (typeof datetime === 'string') {
    if (offset) {
      if (!add_time) {
        return moment
          .utc(datetime)
          .subtract(offset, 'minutes')
          .format(fmt_out)
      } else {
        return moment
          .utc(datetime)
          .add(offset, 'minutes')
          .format(fmt_out)
      }
    }
    return moment
      .utc(datetime)
      .local()
      .format(fmt_out)
  }
  let value = parseInt(datetime.$date.$numberLong)
  let result = ''
  if (value) {
    if (!moment.utc(value).isValid()) return ''
    var fmt_in = moment(value)._f
    if (offset) {
      if (!add_time) {
        result = moment
          .utc(value, fmt_in)
          .subtract(offset, 'minutes')
          .format(fmt_out)
      } else {
        result = moment
          .utc(value, fmt_in)
          .add(offset, 'minutes')
          .format(fmt_out)
      }
    } else {
      result = moment
        .utc(value, fmt_in)
        .local()
        .format(fmt_out)
    }
  }
  return result
}

export function hostname() {
  let host = location.hostname

  //if it is for development match with local.hostname
  if (process.env.NODE_ENV !== 'production') {
    host = host.replace('local.', '')
  }
  return host
}
